import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const getSignificantApi = (report_id) => {
  const config = {
    method: 'get',
    url: `/api/v1/significant_report/${report_id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
